import PageLayout from "../../components/page-layout";
import WhatsAppLinksManager from "../organization/components/WhatsAppLinksManager";
import SupportRequestsTable from './components/SupportRequestsTable';

export default function SupportRequestsPage() {
  return (
    <PageLayout>
      <SupportRequestsTable />
      <WhatsAppLinksManager />
    </PageLayout>
  );
}
